import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/markdown': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M593.9 452.9H46.1C20.7 452.9 0 432.2 0 406.8V105.2C0 79.8 20.7 59.1 46.1 59.1H593.8C619.3 59.1 640 79.8 640 105.2V406.8C640 432.2 619.3 452.9 593.9 452.9zM153.8 360.6V240.6L215.4 317.5 276.9 240.6V360.6H338.5V151.4H276.9L215.4 228.3 153.8 151.4H92.3V360.6H153.8zM566.1 256H504.6V151.4H443.1V256H381.5L473.8 363.7 566.1 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/markdown.js
// module id = FXuD
// module chunks = 144